import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IUploadedProForma } from 'types/db/UploadedProForma';

interface IParams {
    organizationUuid: string;
    dealId: number;
    postData: {
        dealTypeId: number;
        fileName: string;
        fileSize: number;
    };
}

const createUploadedProForma = async ({ organizationUuid, dealId, postData }: IParams): Promise<IUploadedProForma> => {
    const response = await axiosInstance.post(API_ENDPOINTS.UPLOADED_PRO_FORMAS(organizationUuid, dealId), postData);
    return response.data;
};

export const useCreateUploadedProForma = () => useMutation({
    mutationFn: createUploadedProForma,
});

export default useCreateUploadedProForma;
